<template>
	<div class="textContainer">
		<div class="title">Licença de software e contrato de serviço</div>
		<div class="subtitle">[anotações importantes]</div>
		<div class="text">
			[QianguiIOT Technology Co., Ltd.] (doravante referido como "ix cam") lembra aos usuários que leiam
			atentamente e compreendam completamente esta licença de software e contrato de serviço (doravante referido
			como "este Contrato"). O usuário deve ler atentamente e compreender completamente os termos deste contrato,
			especialmente aqueles relacionados à isenção ou limitação da responsabilidade da ix cam, resolução de
			disputas e aplicação da lei. Os termos de isenção ou limitação de responsabilidade serão marcados em
			negrito, que você precisa ler. Por favor, leia com atenção e escolha aceitar ou não aceitar este Contrato
			(menores de idade devem estar acompanhados por responsáveis legais). Seu download, instalação, uso do
			software, aquisição de conta e login serão considerados como sua aceitação deste Contrato e concorda em
			ficar vinculado aos termos deste contrato.
		</div>
		<div class="text">
			ix cam tem o direito de alterar este contrato. Os termos atualizados do contrato serão publicados no site ou
			software oficial e entrarão em vigor a partir da data de publicação.Os usuários podem baixar e instalar o
			software novamente ou verificar a versão mais recente dos termos do contrato no site.Depois do ix cam
			modifica os termos deste acordo, se o usuário não aceitar os termos modificados, por favor, pare
			imediatamente de usar o software e serviços "ix cam" fornecidos pela ix cam. Se o usuário continuar a usar o
			software e os serviços "ix cam" fornecidos pela ix cam, será considerado que ele aceitou o contrato
			modificado.
		</div>
		<div class="title">Ⅰ. Em geral</div>
		<div class="text">
			1.1. Este acordo é um acordo entre você (doravante denominado "usuário") e o ix cam e sua unidade de
			cooperação operacional (doravante denominada "unidade de cooperação") sobre o download, instalação e uso do
			usuário do ix cam " ix cam" (doravante denominado "software") e o uso de serviços relacionados ao ix cam.
		</div>
		<div class="text">
			1.2. Este software e serviço é o software e serviço fornecido pela ix cam e instalado em equipamentos
			terminais móveis inteligentes, incluindo, mas não limitado a, fornecer vinculação, operar produtos
			inteligentes e outros serviços para usuários que utilizam o terminal inteligente.
		</div>
		<div class="text">
			1.3. A propriedade e o direito de operação do software e serviços pertencem à ix cam.
		</div>
		<div class="title">Ⅱ. Escopo da autorização de software</div>
		<div class="text">
			2.1. ix cam oferece aos usuários uma licença pessoal, intransferível, não sublicenciável e não exclusiva
			para este software.
		</div>
		<div class="text">
			2.2. Os usuários podem instalar, usar, exibir e executar o software em um único dispositivo de terminal
			móvel para fins não comerciais. No entanto, o usuário não deve instalar, usar e executar o software para
			fins de operação comercial e não deve copiar, alterar, modificar, conectar e executar o software ou os
			dados liberados na memória de qualquer equipamento terminal durante a operação do software e os dados
			interativos entre o cliente e o servidor durante a operação do software, ou criar quaisquer trabalhos
			derivados, incluindo, mas não se limitando a o uso de plug-insPlug in ou ferramentas/serviços de
			terceiros não autorizados acessam o software e sistemas relacionados.Se for necessário vender, copiar e
			distribuir comercialmente, como pré-instalação e vinculação de software, deve obter a autorização e
			licença por escrito do ix cam.
		</div>
		<div class="text">
			2.3. O usuário não deve instalar o software em outros equipamentos terminais sem a permissão expressa da
			ix cam, incluindo, mas não se limitando a decodificadores, console de jogos, TV, DVD player, etc.
		</div>
		<div class="text">
			2.4. Os usuários podem copiar uma cópia do software com a finalidade de usar o software e os serviços e
			usá-lo apenas como backup. A cópia de backup deve conter todas as informações de direitos autorais
			contidas no software original.
		</div>
		<div class="text">
			2.5. Além da autorização expressa neste contrato, o ix cam não autoriza usuários com outros direitos. Se
			os usuários usarem outros direitos, eles devem obter o consentimento por escrito do ix cam.
		</div>
		<div class="title">Ⅲ. Aquisição, instalação e atualização de software</div>
		<div class="text">
			3.1. Os usuários devem baixar e instalar o produto de software de acordo com o site ou método designado
			do ix cam. Cuidado ao baixar o software em sites não designados para evitar que o dispositivo de
			terminal móvel infecte programas maliciosos que podem destruir os dados do usuário e obter informações
			de privacidade do usuário. Caso o usuário não tenha obtido o software ou o programa de instalação com o
			mesmo nome do software de um terceiro autorizado pela ix cam, a ix cam não pode garantir o uso normal do
			software, e não será responsável pelos prejuízos causados para você.
		</div>
		<div class="text">
			3.2. O usuário deve selecionar a versão do software compatível com o equipamento terminal instalado,
			caso contrário, quaisquer problemas de software, problemas de equipamento ou danos causados pela
			incompatibilidade entre o software e o modelo do equipamento serão de responsabilidade do usuário.
		</div>
		<div class="text">
			3.3. A fim de melhorar a experiência do usuário e o conteúdo do serviço, ix cam tem o direito de
			fornecer a você versões de substituição, modificação e atualização do software de tempos em tempos, e
			também tem o direito de cobrar taxas de substituição, modificação ou atualização, mas as taxas serão
			aprovadas por você com antecedência. O software habilita a função "prompt de atualização" para os
			usuários por padrão. Dependendo da versão do software usada pelos usuários, o ix cam oferece aos
			usuários a opção de habilitar esta função. Após o lançamento da nova versão do software, o ix cam não
			garante a disponibilidade contínua da versão antiga do Programas.
		</div>
		<div class="title">Ⅳ. Especificação de uso</div>
		<div class="text">
			4.1. Com a premissa de cumprir as leis e este contrato, o usuário pode usar o software e os serviços de
			acordo com este contrato. O usuário não deve praticar os seguintes atos:
		</div>
		<div class="text">
			• 4.1.1. Excluir todas as informações sobre direitos autorais do software e outras cópias e modificar,
			excluir ou evitar as medidas técnicas estabelecidas pelo software para proteger os direitos de
			propriedade intelectual;
		</div>
		<div class="text">
			• 4.1.2. Engenharia reversa do software, como desmontagem, descompilação ou outras tentativas de obter o
			código-fonte do software;
		</div>
		<div class="text">
			• 4.1.3. Adicionar, excluir ou alterar a função ou efeito de operação do software modificando ou
			falsificando as instruções e dados na operação do software, ou operar o software e métodos usados para
			os fins acima ou divulgá-los ao público, sejam esses atos para fins comerciais ou não;
		</div>
		<div class="text">
			• 4.1.4. Use o software para cometer qualquer comportamento que coloque em risco a segurança da rede,
			incluindo, mas não limitado a: usar dados não licenciados ou entrar em servidor/conta não licenciado;
			Entrar na rede pública ou no sistema operacional de outras pessoas sem permissão e excluir, modificar ou
			adicionar informações armazenadas; Tentar detectar , verificar e testar a fraqueza do sistema ou rede do
			software ou outros atos que prejudiquem a segurança da rede sem permissão; Tentar interferir e destruir
			a operação normal do sistema ou site do software, espalhar deliberadamente programas ou vírus maliciosos
			e outros atos que destroem e interferem nos serviços normais de informação da rede;Forja o nome do
			pacote TCP/IP ou o nome parcial;
		</div>
		<div class="text">
			• 4.1.5. O usuário efetua login ou utiliza o software e serviços através de um software ou sistema
			compatível de terceiros não desenvolvido, autorizado ou aprovado pela empresa ix cam, ou faz, publica e
			divulga as ferramentas acima;
		</div>
		<div class="text">
			• 4.1.6. Sem o consentimento por escrito da ix cam, o usuário realiza o software e suas informações sem
			autorização, incluindo, mas não se limitando aos seguintes atos: usar, alugar, emprestar, copiar,
			modificar, vincular, reimprimir, compilar, publicar, publicar, estabelecer um site espelho e desenvolver
			produtos derivados relevantes, trabalhos, serviços, plug-ins, plug-ins, compatibilidade, interconexão,
			etc. com a ajuda do software sem autorização;
		</div>
		<div class="text">
			• 4.1.7. Use este software para publicar, transmitir, disseminar e armazenar conteúdo que viole as leis
			e regulamentos locais;
		</div>
		<div class="text">
			• 4.1.8. Usar este software para publicar, transmitir, disseminar e armazenar conteúdos que infrinjam os
			direitos de propriedade intelectual, segredos comerciais e outros direitos legítimos de outras pessoas;
		</div>
		<div class="text">
			• 4.1.9. Use este software para publicar, transmitir e divulgar informações publicitárias e informações
			de lixo em lotes;
		</div>
		<div class="text">
			• 4.1.10. Usar o software e outros serviços fornecidos pelo ix cam de qualquer forma ilegal, para
			qualquer finalidade ilegal, ou de qualquer forma inconsistente com o uso licenciado deste Contrato;
		</div>
		<div class="text">
			4.2. Especificação de liberação de informações
		</div>
		<div class="text">
			• 4.2.1. Você pode usar este software para publicar suas visualizações originais, dados, texto,
			informações, nome de usuário, imagens, fotos, informações pessoais, áudio, arquivos de vídeo, links e
			outros conteúdos informativos. Você deve garantir que possui os direitos de propriedade intelectual do
			informações que você carrega ou obteve autorização legal, e qualquer comportamento que você usa este
			software e serviços não infringe os direitos e interesses legítimos de terceiros.
		</div>
		<div class="text">
			• 4.2.2. Você deve cumprir as leis e regulamentos locais ao usar o software.
		</div>
		<div class="text">
			4.2.3. ao usar o software, você não deve usar o software para se envolver nos seguintes atos, incluindo,
			mas não limitado a:
		</div>
		<div class="text">
			4.2.3.1.Fazer, copiar, publicar, divulgar e armazenar conteúdos que violem as leis e regulamentos
			locais;
		</div>
		<div class="text">
			4.2.3.2. Publicar, transmitir, divulgar e armazenar conteúdos que infrinjam direitos legítimos de
			terceiros, como direito de reputação, direito de retrato, direito de propriedade intelectual e segredo
			comercial;
		</div>
		<div class="text">
			4.2.3.3.Inventar fatos e ocultar a verdade para enganar e enganar os outros;
		</div>
		<div class="text">
			4.2.3.4. Publicar, transmitir e divulgar informações publicitárias e lixo;
		</div>
		<div class="text">
			4.2.3.5. Praticar outros atos que violem as leis e regulamentos locais.
		</div>
		<div class="text">
			4.2.4. Sem a permissão da ix cam, você não deve realizar nenhuma atividade comercial, como publicidade e
			venda de mercadorias neste software.
		</div>
		<div class="title">4.3. Você entende e concorda que:</div>
		<div class="text">
			• 4.3.1. O ix cam determinará se o usuário é suspeito de violar as especificações de uso acima e
			suspenderá ou encerrará sua licença de uso ou tomará outras medidas restritivas de acordo com este
			contrato de acordo com os resultados da determinação;
		</div>
		<div class="text">
			• 4.3.2. O ix cam excluirá diretamente as informações divulgadas pelo usuário ao usar o software
			licenciado suspeito de infringir a lei ou infringir os direitos legítimos de terceiros ou violar este
			Contrato;
		</div>
		<div class="text">
			• 4.3.3. Se a violação do usuário das especificações de uso acima causar danos a terceiros, você precisa
			arcar com a responsabilidade legal de forma independente em seu próprio nome e garantir que o ix cam
			esteja livre de perdas ou aumento de despesas;
		</div>
		<div class="text">
			• 4.3.4. Se o usuário violar as leis e regulamentos ou acordos relevantes, resultando em perdas para a
			ix cam, reclamações de terceiros ou penalidades de autoridades administrativas, o usuário deverá
			compensar a ix cam pelas perdas e/ou despesas incorridas, incluindo advogado razoável honorários e
			despesas de investigação e coleta de provas.
		</div>
		<div class="title">Ⅴ. Risco de serviço e isenção de responsabilidade</div>
		<div class="text">
			5.1. Os usuários devem equipar seu próprio equipamento terminal móvel para acessar a Internet e usar o
			equipamento necessário para serviços de telecomunicações de valor agregado, e arcar com as taxas de
			comunicação, taxas de informação e outras taxas relacionadas cobradas por equipamentos terminais móveis
			pessoais ou terceiros (incluindo, mas não limitado a para provedores de telecomunicações ou de
			comunicações móveis). Se serviços de valor agregado de telecomunicações estiverem envolvidos, sugerimos
			que você confirme as taxas relevantes com seu provedor de serviços de valor agregado de
			telecomunicações.
		</div>
		<div class="text">
			5.2. A ix cam e as unidades cooperativas não se responsabilizam por todas as perdas sofridas pelos
			usuários devido a terceiros, como falha na linha de comunicação, problemas técnicos, rede, falha no
			equipamento do terminal móvel, instabilidade do sistema e outros motivos de força maior.
		</div>
		<div class="text">
			5.3. Como a maioria dos softwares de Internet, este software é afetado por fatores que incluem, entre
			outros, motivos do usuário, qualidade do serviço de rede, ambiente social e assim por diante, e pode ser
			invadido por vários problemas de segurança, como assédio na vida real causado por outras pessoas que
			usam dados do usuário ;Outros softwares baixados e instalados por usuários ou outros sites visitados por
			usuários contêm vírus como "Cavalo de Tróia", que ameaçam a segurança das informações e dados do
			equipamento terminal do usuário e, em seguida, afetam o uso normal do software. Os usuários devem
			fortalecer a conscientização de segurança da informação e proteção de dados do usuário, e preste atenção
			ao fortalecimento da proteção por senha para evitar perdas e assédio
		</div>
		<div class="text">
			5.4. Quando os usuários usam o software ou exigem que o ix cam forneça serviços específicos, o software
			pode chamar um sistema de terceiros ou software de terceiros para dar suporte ao uso ou acesso dos
			usuários, e os resultados do uso ou acesso são fornecidos pelo terceiro . ix cam não garante a
			segurança, precisão e confiabilidade dos resultados suportados pelo sistema de terceiros ou software de
			terceiros Validade e outros riscos incertos. A ix cam não assume qualquer responsabilidade por qualquer
			litígio e danos daí decorrentes.
		</div>
		<div class="text">
			5.5. A ix cam lembra especialmente aos usuários que para garantir a autonomia do desenvolvimento e
			ajuste dos negócios da empresa, a empresa ix cam tem o direito de modificar ou interromper o serviço a
			qualquer momento sem notificar os usuários. A ix cam não se responsabiliza perante os usuários ou
			terceiros pelo exercício do direito de modificar ou interromper o serviço.
		</div>
		<div class="text">
			5.6. A menos que especificado de outra forma por leis e regulamentos, faremos o possível para garantir
			que o software, a tecnologia e as informações envolvidas sejam seguros, eficazes, precisos e confiáveis.
			No entanto, limitados pela tecnologia existente, os usuários entendem que o ix cam não pode garantir
			isso.
		</div>
		<div class="text">
			5.7. Danos pessoais ou danos econômicos incidentais e indiretos causados por ou relacionados ao usuário
			devido a qualquer uma das seguintes circunstâncias, incluindo, mas não se limitando a compensação por
			lucros cessantes, perda de dados, interrupção de negócios ou outros danos ou perdas comerciais, serão
			suportados pelo usuário:
		</div>
		<div class="text">
			• 5.7.1.Uso ou não uso do software licenciado;
		</div>
		<div class="text">
			• 5.7.2. Uso não autorizado de software ou alteração de dados do usuário por terceiros;
		</div>
		<div class="text">
			• 5.7.3.Despesas e perdas decorrentes do comportamento do usuário ao utilizar o software;
		</div>
		<div class="text">
			• 5.7.4.Incompreensão do software pelo usuário;
		</div>
		<div class="text">
			• 5.7.5.Outras perdas relacionadas ao software não causadas pelo ix cam.
		</div>
		<div class="text">
			5.8. Qualquer dano ou prejuízo pessoal ou econômico causado ou provavelmente causado por engano ou
			engano será arcado pela parte culpada de acordo com a lei.
		</div>
		<div class="title">Ⅵ. Declaração de propriedade intelectual</div>
		<div class="text">
			6.1. ix cam é o proprietário da propriedade intelectual do software. Todos os direitos autorais, marcas
			registradas, patentes, segredos comerciais e outros direitos de propriedade intelectual do software, bem
			como todo o conteúdo de informação relacionado ao software (incluindo, mas não limitado a palavras,
			imagens, áudio, vídeo, gráficos, design de interface, estrutura de layout, dados relevantes ou
			documentos eletrônicos, etc.) são protegidos por suas leis e regulamentos locais e tratados
			internacionais correspondentes, o ix cam goza dos direitos de propriedade intelectual acima.
		</div>
		<div class="text">
			6.2 Sem o consentimento por escrito da ix cam, o usuário não deve implementar, utilizar ou transferir os
			direitos de propriedade intelectual acima para qualquer finalidade comercial ou não comercial por si
			mesmo ou por licenciamento de terceiros. A ix cam se reserva o direito de investigar a responsabilidade
			legal pelos atos acima.
		</div>
		<div class="title">Ⅶ. Mudança de acordo</div>
		<div class="text">
			7.1. A ix cam tem o direito de modificar os termos deste contrato quando necessário. Assim que os termos
			do contrato forem alterados, os termos modificados do contrato serão publicados nas páginas
			relevantes.Se você não concordar com o conteúdo alterado, o usuário deve tomar a iniciativa de cancelar
			o serviço.Se o usuário continuar a usar o serviço, considera-se que aceita a alteração dos termos do
			contrato.
		</div>
		<div class="text">
			7.2. A ix cam e a empresa cooperativa têm o direito de modificar ou alterar os serviços de cobrança,
			padrões de cobrança, métodos de cobrança, taxas de serviço e termos de serviço conforme necessário.
			serviços agora ou no futuro. Se os usuários se recusarem a pagar essas taxas, eles não poderão continuar
			a usar os serviços relevantes após o início da cobrança. A ix cam e a empresa cooperativa farão o
			possível para notificar os usuários sobre modificações ou alterações relevantes por e-mail ou outros
			meios.
		</div>
		<div class="title">Ⅷ. Lei aplicável e resolução de disputas</div>
		<div class="text">
			8.1. A validade e interpretação dos termos deste Contrato serão regidas pelas leis do continente da
			República Popular da China. Se não houver leis relevantes, as práticas comerciais internacionais e/ou
			práticas comerciais devem ser usadas como referência.
		</div>
		<div class="text">
			8.2. Este acordo é assinado no distrito de Haidian, em Pequim.
		</div>
		<div class="text">
			8.3. O usuário e a ix cam concordam que todas as disputas decorrentes deste serviço serão resolvidas por
			ambas as partes por meio de negociação. Se a negociação falhar, qualquer uma das partes pode apresentar
			ao tribunal com jurisdição no local onde este acordo é assinado para litígio.
		</div>
		<div class="title">Ⅸ. Outro</div>
		<div class="text">
			9.1. Quando os usuários usam um serviço específico do software, o serviço pode ter acordos separados e
			regras de negócios relevantes (doravante coletivamente denominados "acordos separados"). Leia e concorde
			com os acordos separados relevantes antes de usar o serviço.
		</div>
		<div class="text">
			9.2. Este acordo entra em vigor em 13 de março de 2018.
		</div>
		<div class="text">
			9.3. Os títulos de todas as cláusulas deste Contrato são apenas para conveniência de leitura e não têm
			significado real em si mesmos, o que não pode ser usado como base para a interpretação do significado
			deste contrato.
		</div>
		<div class="text">
			9.4. Não importa o motivo, algumas disposições deste Contrato são inválidas ou inexequíveis, as demais
			disposições permanecerão válidas e vinculativas para ambas as partes.
		</div>
		<div class="text">
			ix cam
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.textContainer {
		padding: 0 50px;

		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: 900;
		}

		.subtitle {
			font-size: 25px;
			margin: 10px 0;
			font-weight: 600;
		}
	}
</style>